import React, { Component } from 'react';
import { connect } from 'react-redux'
import { View, StyleSheet, Text, Platform } from 'react-native';
import { LoadingModal } from '../ui';
import { UserDataConsumer } from '../utils';
import { AuthTokenBuilder } from 'fitbeat.react-native-components/utils/authTokenBuilder';
import { BootstrapClient } from 'fitbeat.api-clients';
import { getApiConfig, APP_STORE_LINK, PLAY_STORE_LINK } from '../config';
import { getHomeLoadingRouteAndRouter } from 'fitbeat.gym-core';
import ConnectedAppsManagerSingleton from '../ConnectedApps';
import { Button } from '../components';
import { clearDeepLinkParams } from '../utils/notifications/actions';
import Theme from '../theme';
import { GymResolver } from '../services';
import { deepLinkParamsSelector, enabledFeaturesSelector } from '../auth/auth-selectors'
import { openLink } from '../utils/linkUtils';

class HomeLoadingScreen extends Component {
  state = {
    bootstrapData: undefined,
  }
  bootstrap = new BootstrapClient(getApiConfig(), fetch, console.log, new AuthTokenBuilder());

  componentDidMount = async () => {
    console.log('[HomeLoadingScreen] componentDidMount', {
      connectedApps: ConnectedAppsManagerSingleton.connectedApps.length, // logged, to import it and initialize it
    });
    const bootstrapData = await this.bootstrap.getDetails();
    this.setState({
      ... this.state,
      bootstrapData,
    });
  };

  canNavigate = () => {
    const { user: { isUserProfileServiceReady }, enabledFeatures } = this.props;
    if (!enabledFeatures) {
      return false;
    }
    if (this.state.bootstrapData === undefined) {
      console.log('[HomeLoadingScreen] waiting for bootstrap data');
      return false;
    } else if (this.state.bootstrapData && this.state.bootstrapData.mustUpdate) {
      console.log('[HomeLoadingScreen] app must be updated');
      return false;
    } else if (isUserProfileServiceReady) {
      console.log('[HomeLoadingScreen] service is ready');
      return true;
    }

    return false;
  };

  handleNavigation = async () => {
    console.log('[HomeLoadingScreen] handleNavigation');
    const {
      user: { userProfile },
      navigation: { navigate, replace },
      clearDeepLinkParams,
      deepLinkParameters,
      enabledFeatures,
    } = this.props;
    const dashboardRoute = Platform.OS === 'web' ? 'SummaryDashboard' : 'DashboardTabNavigator';
    const { navigationFunction, route: destinationRoute } = getHomeLoadingRouteAndRouter(
      dashboardRoute,
      Platform.OS,
      userProfile,
      clearDeepLinkParams,
      navigate,
      replace,
      deepLinkParameters,
      GymResolver.getByName(userProfile.gymName),
      enabledFeatures
    )
    navigationFunction(destinationRoute)
  };

  openStoreToApp = () => {
    if (Platform.OS === 'ios') {
      openLink(APP_STORE_LINK);
    } else {
      openLink(PLAY_STORE_LINK);
    }
  }

  render() {
    if (this.canNavigate()) {
      this.handleNavigation();
    }

    const isLoading = this.state.bootstrapData === undefined;
    if (this.state.bootstrapData && this.state.bootstrapData.mustUpdate) {
      return (
        <View style={styles.container}>
          <Text style={styles.updateText}>
            You must update to a newer version of the Fitillion app to continue
          </Text>
          <Button
            title='Update Now'
            onPress={this.openStoreToApp}
          />
        </View>
      );
    }

    return (
      <View style={styles.container}>
        <LoadingModal isLoading={isLoading} />
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 20,
    justifyContent: 'center',
    minHeight: '100%',
    backgroundColor: Theme.WHITE,
  },
  updateText: {
    fontSize: 20,
    color: Theme.DARK_CHARCOAL,
    paddingVertical: 15,
    textAlign: 'center',
    paddingHorizontal: 15
  },
});

const mapStateToProps = (state) => ({
  deepLinkParameters: deepLinkParamsSelector(state),
  enabledFeatures: enabledFeaturesSelector(state),
});

const mapDispatchToProps = (dispatch) => {
  return {
    clearDeepLinkParams: (keysToClear) => dispatch(clearDeepLinkParams(keysToClear)),
  };
};

HomeLoadingScreen = connect(mapStateToProps, mapDispatchToProps)(HomeLoadingScreen);
export default UserDataConsumer(HomeLoadingScreen);
